import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import PracticePageContent from "../_PracticePageContent";

import { useLazyGetThemePracticeAssignmentsQuery, useGetUserThemeByIdQuery } from "api/generated";
import type { UserAssignmentPracticeFragment } from "api/generated";

import { processApiError } from "utils/processApiError";

const SuperTopicPractice = () => {
  const { themeId } = useParams();
  if (themeId === undefined) return null;

  const {
    data: themeData,
    isLoading: isThemeLoading,
    error: apiThemeError,
  } = useGetUserThemeByIdQuery({ userThemeId: themeId });

  const [trigger, { data: assignmentsData, isLoading: isAssignmentsLoading, error: lazyAssignmentsError }] =
    useLazyGetThemePracticeAssignmentsQuery();

  const [allAssignments, setAllAssignments] = useState<UserAssignmentPracticeFragment[] | null>(null);

  useEffect(() => {
    if (apiThemeError === undefined) return;

    processApiError(apiThemeError);
  }, [apiThemeError]);

  useEffect(() => {
    if (lazyAssignmentsError === undefined) return;

    processApiError(lazyAssignmentsError);
  }, [lazyAssignmentsError]);

  useEffect(() => {
    const themeId = themeData?.userTheme.theme?.id;
    if (!themeId) return;

    trigger({ themeId }).catch(() => {});
  }, [themeData]);

  useEffect(() => {
    if (assignmentsData === undefined) return;

    const assignmentsItems = assignmentsData.userAssignmentsCached.items.filter(assignment => assignment.envelope);
    setAllAssignments(assignmentsItems);
  }, [assignmentsData]);

  return (
    <PracticePageContent
      isLoading={isThemeLoading || isAssignmentsLoading}
      assignments={allAssignments}
      title={themeData?.userTheme.theme?.appName ?? themeData?.userTheme.theme?.name ?? ""}
      topicId={themeId}
    />
  );
};

export default SuperTopicPractice;
